import axios from "axios";
import baseURL from "./../api";
class AutoPayService {
    constructor() {
        this.time = new Date().getTime();
    }
    getAutoPayAgents(distributorId) {
        if(!distributorId) {
            distributorId = ''
        }
        return axios.get(`${baseURL}/autopay?distributorId=${distributorId}`);
    }

    setAutoPay(data) {
        return axios.post(`${baseURL}/autopay`,data);
    }
    setAutoPaySystemUpdate(data) {
        return axios.post(`${baseURL}/autopay/system`,data);
    }
   
}
export default new AutoPayService();